import React, { useMemo } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { ActionsMenuLayout } from '@wix/wix-ui-tpa/cssVars';
import {
  getManageOptions,
  getReportOption,
  getViewDownloadOptions,
} from './helper';
import { ITEM_MENU_OPTIONS } from '../../../../../../../../../Constants/ItemMenu.Constant';
import { st, classes } from '../ItemActionsMenu.st.css';
import useObservable from '../../../../../../../../../Shared/Hooks/useObservable.Hook';
import { getAppSettings } from '../../../../../../../../Services/AppSettings.service';

export const MenuOptions = ({ handleOnClick, canManage, item }: any) => {
  const { t } = useTranslation();
  const [, AppSettings]: any = useObservable(getAppSettings());
  const isMobile = AppSettings !== undefined ? AppSettings?.isMobile : '';

  const renderedOptions = useMemo(() => {
    const tempView = getViewDownloadOptions(t);
    const tempReport = getReportOption(t);
    const dividerOption = { type: ITEM_MENU_OPTIONS.DIVIDER };
    let opts: any[];
    if (canManage) {
      const tempManage = getManageOptions(t);
      opts = [
        ...tempView,
        dividerOption,
        ...tempManage,
        dividerOption,
        ...tempReport,
      ];
    } else {
      opts = [...tempView, dividerOption, ...tempReport];
    }
    let disabled = false;
    return opts.map((option: any, index: number) => {
      disabled =
        option.type === ITEM_MENU_OPTIONS.DOWNLOAD &&
        item?.folderFields?.childrenCount <= 0;
      if (option.type === ITEM_MENU_OPTIONS.DIVIDER) {
        return <ActionsMenuLayout.Divider key={`divider-${index}`} />;
      }
      return (
        <ActionsMenuLayout.Item
          key={option.type}
          content={option.content}
          onClick={() => handleOnClick(option.type)}
          disabled={disabled}
        />
      );
    });
  }, [canManage, t, item, handleOnClick]);

  return (
    <ActionsMenuLayout
      className={st(classes.actionsMenuLayoutContainer, { isMobile })}
    >
      {renderedOptions}
    </ActionsMenuLayout>
  );
};
